/** Build /api URLs for public delivery (dev proxy on same origin, or REACT_APP_API_URL in production). */
function getApiBase(): string {
  const explicit =
    process.env.REACT_APP_DELIVERY_API_URL?.trim() || process.env.REACT_APP_API_URL?.trim();
  if (explicit) {
    const normalized = explicit.replace(/\/$/, '');
    return normalized.endsWith('/api') ? normalized : `${normalized}/api`;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/api`;
  }

  return '/api';
}

export function buildDeliveryStreamUrl(apiBase: string, code: string, download = false): string {
  const base = apiBase.replace(/\/$/, '');
  const q = download ? '?download=true' : '';
  return `${base}/videos/delivery/stream/${encodeURIComponent(code)}${q}`;
}

export function getDeliveryInfoUrl(code: string): string {
  return `${getApiBase()}/videos/delivery/info/${encodeURIComponent(code)}`;
}

/** Prefer URLs returned by the API (correct host behind proxy or split deployment). */
export function resolveDeliveryUrls(
  code: string,
  info?: { apiBaseUrl?: string; streamUrl?: string; downloadUrl?: string } | null
): { streamUrl: string; downloadUrl: string } {
  if (info?.streamUrl && info?.downloadUrl) {
    return { streamUrl: info.streamUrl, downloadUrl: info.downloadUrl };
  }

  const origin = info?.apiBaseUrl?.trim() || getApiBase().replace(/\/api$/i, '');
  const apiBase = origin ? `${origin.replace(/\/$/, '')}/api` : getApiBase();
  return {
    streamUrl: buildDeliveryStreamUrl(apiBase, code, false),
    downloadUrl: buildDeliveryStreamUrl(apiBase, code, true),
  };
}
